import { DialogComponent, DialogOpenEvent } from '@theme/dialog';

/**
 * Lightbox for the Samyang product gallery block.
 *
 * Extends the theme's DialogComponent with an `open(index)` entry point so a
 * thumbnail can open the dialog *and* jump the slideshow to its own image in
 * one declarative binding:
 *
 *   on:click="#samyang-gallery-{block.id}/open/{forloop.index0}"
 *
 * The slideshow lives inside a closed <dialog>, so its scroller has no layout
 * until the dialog is shown. Selecting the slide before then is a no-op, hence
 * the wait for `dialog:open` rather than an immediate call.
 *
 * @extends DialogComponent
 */
export class SamyangGallery extends DialogComponent {
  /**
   * Opens the lightbox with a given slide showing.
   *
   * @param {number|string} index - Zero-based index of the image to show.
   * @param {Event} [event] - The click event that triggered the open.
   */
  open(index, event) {
    event?.preventDefault();

    const slideshow = this.querySelector('slideshow-component');

    if (slideshow) {
      const target = Number(index) || 0;

      this.addEventListener(
        DialogOpenEvent.eventName,
        () => {
          // The slideshow may still be an un-upgraded element on a slow
          // connection; upgrading is synchronous and a no-op once done.
          customElements.upgrade(slideshow);

          if (typeof (/** @type {any} */ (slideshow).select) === 'function') {
            /** @type {any} */ (slideshow).select(target, undefined, { animate: false });
          }
        },
        { once: true }
      );
    }

    this.showDialog();
  }
}

if (!customElements.get('samyang-gallery-component')) {
  customElements.define('samyang-gallery-component', SamyangGallery);
}
